import {
  fetchHostState,
  displayOpen,
  displayClose,
  DISPLAY_OPEN,
  DISPLAY_CLOSE,
  RECEIVE_DISPLAY_OPEN,
  RECEIVE_DISPLAY_CLOSE,
  RECEIVE_REMOTE_CLOSE,
  REMOTE_CLOSE,
  remoteClose,
  SHARE_OVER_WIRE_RECEIVE,
  SHARE_OVER_WIRE_SEND,
  shareOverWire,
} from "./data/pairing";
import { SEND_GROUPS, RECEIVE_GROUPS } from "src/pods/groups";
import { SEND_IDEAS, RECEIVE_IDEAS } from "src/pods/ideas";
import {
  SEND_NOISE,
  RECEIVE_NOISE,
  SEND_MICROPHONE_PERMISSION_ERROR,
  RECEIVE_MICROPHONE_PERMISSION_ERROR,
} from "src/pods/noise";
import { SEND_RADIO, RECEIVE_RADIO } from "src/pods/radio";

import { MESSAGE } from "@web-monorepo/realtime/toolkit-iframe";

export { MESSAGE };
export { fetchHostState, displayOpen, displayClose, remoteClose, shareOverWire };

// Maps incoming postMessage types (MESSAGE.*) from the teach parent iframe bridge
// to toolkit Redux actions. Used by the display iframe's RealtimeClient message handler.
export function mapToAction({ type, payload }: { type: string; payload?: Record<string, unknown> }) {
  switch (type) {
    case MESSAGE.SEND_GROUPS:
      return { type: RECEIVE_GROUPS, payload };
    case MESSAGE.SEND_RADIO:
      return { type: RECEIVE_RADIO, payload };
    case MESSAGE.SEND_NOISE:
      return { type: RECEIVE_NOISE, payload };
    case MESSAGE.SEND_MICROPHONE_PERMISSION_ERROR:
      return { type: RECEIVE_MICROPHONE_PERMISSION_ERROR, payload };
    case MESSAGE.SEND_IDEAS:
      return { type: RECEIVE_IDEAS, payload };
    case MESSAGE.DISPLAY_OPEN:
      return { type: RECEIVE_DISPLAY_OPEN, payload };
    case MESSAGE.SHARE_OVER_WIRE_SEND:
      return { type: SHARE_OVER_WIRE_RECEIVE, payload };
    case MESSAGE.DISPLAY_CLOSE:
      return { type: RECEIVE_DISPLAY_CLOSE };
    case MESSAGE.REMOTE_CLOSE:
      return { type: RECEIVE_REMOTE_CLOSE };
    default:
      return null;
  }
}

// Maps toolkit Redux actions to MESSAGE.* types for publishing via the
// RealtimeClient (IframeAdapter → postMessage to teach parent).
export function mapFromAction({ type, payload }: { type: string; payload?: Record<string, unknown> }) {
  switch (type) {
    case SEND_GROUPS:
      return { type: MESSAGE.SEND_GROUPS, payload };
    case SEND_RADIO:
      return { type: MESSAGE.SEND_RADIO, payload };
    case SEND_NOISE:
      return { type: MESSAGE.SEND_NOISE, payload };
    case SEND_MICROPHONE_PERMISSION_ERROR:
      return { type: MESSAGE.SEND_MICROPHONE_PERMISSION_ERROR, payload };
    case SEND_IDEAS:
      return { type: MESSAGE.SEND_IDEAS, payload };
    case DISPLAY_OPEN:
      return { type: MESSAGE.DISPLAY_OPEN, payload };
    case SHARE_OVER_WIRE_SEND:
      return { type: MESSAGE.SHARE_OVER_WIRE_SEND, payload };
    case DISPLAY_CLOSE:
      return { type: MESSAGE.DISPLAY_CLOSE };
    case REMOTE_CLOSE:
      return { type: MESSAGE.REMOTE_CLOSE };
    default:
      return null;
  }
}

export function mapFromActionToNats(
  { type, payload }: { type: string; payload?: Record<string, unknown> },
  senderId: string,
): { action: string; payload: Record<string, unknown> } | null {
  switch (type) {
    case SEND_GROUPS:
      return { action: "toolkit:send-groups", payload: { senderId, data: payload } };
    case SEND_RADIO:
      return { action: "toolkit:send-radio", payload: { senderId, data: payload } };
    case SEND_NOISE:
      return { action: "toolkit:send-noise", payload: { senderId, data: payload } };
    case SEND_MICROPHONE_PERMISSION_ERROR:
      return { action: "toolkit:send-microphone-error", payload: { senderId, data: payload } };
    case SEND_IDEAS:
      return { action: "toolkit:send-ideas", payload: { senderId, data: payload } };
    case DISPLAY_OPEN:
      return { action: "toolkit:display-open", payload: { senderId, ...payload } };
    case SHARE_OVER_WIRE_SEND:
      return { action: "toolkit:share-over-wire", payload: { senderId, action: payload } };
    case DISPLAY_CLOSE:
      return { action: "toolkit:display-close", payload: { senderId } };
    case REMOTE_CLOSE:
      return { action: "toolkit:remote-close", payload: { senderId } };
    default:
      return null;
  }
}
